import {
  isCleanroom,
  isClothing,
  isNonClothing,
  NavigationLinks,
  ServiceSegmentCategory,
} from '@mewa/types';

import { Industry } from './components/industry-page-types';

export const hasCleanroomSegments = (industry: {
  serviceSegments: {
    slug: string;
    category: ServiceSegmentCategory;
  }[];
}) => industry.serviceSegments.filter((s) => isCleanroom(s)).length > 0;

export const getIndustryTabs = (
  industry: Industry,
  langPrefix: string,
  navigation: NavigationLinks['navigation'],
  marketHasClothing: boolean,
  featureDev = false,
) => {
  const tabLinks = industry.serviceSegments
    .filter(featureDev && !marketHasClothing ? () => true : isClothing)
    .map((s) => ({
      label: s.name,
      to: `${langPrefix}/${industry.slug}-${s.slug}`,
    }));

  const hasSummarizedNonClothingIndustryPage =
    featureDev && !marketHasClothing
      ? false
      : industry.serviceSegments.filter((s) => isNonClothing(s)).length > 0;

  if (hasSummarizedNonClothingIndustryPage) {
    tabLinks.push({
      label: navigation.nonClothing.name,
      to: `${langPrefix}/${industry.slug}-${navigation.nonClothing.slug}`,
    });
  }

  if ((!featureDev || marketHasClothing) && hasCleanroomSegments(industry)) {
    tabLinks.unshift({
      label: navigation.cleanroom.name,
      to: `${langPrefix}/${industry.slug}-${navigation.cleanroom.slug}`,
    });
  }

  return tabLinks;
};

export const getServiceSegmentSlugForIndustry = (
  industry: {
    serviceSegments: {
      slug: string;
      category: ServiceSegmentCategory;
    }[];
  },
  navigation: NavigationLinks['navigation'],
  marketHasClothing: boolean,
  featureDev = false,
) => {
  return featureDev && !marketHasClothing
    ? industry.serviceSegments[0].slug
    : hasCleanroomSegments(industry)
      ? navigation.cleanroom.slug
      : isClothing(industry.serviceSegments[0])
        ? industry.serviceSegments[0].slug
        : navigation.nonClothing.slug;
};
